import useSWR from 'swr';
import { Api } from 'domain/core';
import { IndicatorUnit, Paged, RequiredSwrResponse, RestQueryExtras, Unit } from 'domain/models';
import {
  Indicator,
  IndicatorDataSource,
  UpdateSourceList,
  VariableState,
} from 'domain/models/data.models';
import { toPaginationQuery } from 'domain/utils';

export const useIndicators = (): RequiredSwrResponse<Indicator[], any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}${Api.data.indicators.base}`
  );
  return { data, isValidating, error, mutate, revalidate };
};

export const useDataSources = (
  extras: RestQueryExtras
): RequiredSwrResponse<Paged<IndicatorDataSource>, any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}${Api.admin.sources}${toPaginationQuery(extras)}`
  );
  return { data, isValidating, error, mutate, revalidate };
};

export const useDataSource = (
  indicator: string
): RequiredSwrResponse<IndicatorDataSource, any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}${Api.admin.sources}/${indicator}`
  );
  return { data, isValidating, error, mutate, revalidate };
};

export const useIndicatorsSources = (): RequiredSwrResponse<
  Indicator[],
  any
> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}${Api.data.indicators.sources}`
  );
  return { data, isValidating, error, mutate, revalidate };
};

export const useExternalSources = (): RequiredSwrResponse<Indicator[], any> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}${Api.data.indicators.externalSources}`
  );
  return { data, isValidating, error, mutate, revalidate };
};

export const useUpdatesSources = (): RequiredSwrResponse<
  UpdateSourceList,
  any
> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}${Api.admin.sources}/updates`,
    { suspense: true }
  );
  return { data, isValidating, error, mutate, revalidate };
};

export const useVariableState = (): RequiredSwrResponse<
  Paged<VariableState>,
  any
> => {
  const { data, isValidating, error, mutate, revalidate } = useSWR(
    `${Api.baseUrl}/variableState?page=0&size=1000`
  );

  return { data, isValidating, error, mutate, revalidate };
};
